import { FieldError, Merge } from 'react-hook-form'

type Props = {
  field: FieldError | Merge<FieldError, (FieldError | undefined)[]> | undefined
}
export const DisplayError = ({ field }: Props) => {
  return <>{field && <p style={{ color: 'red' }}>{field.message}</p>}</>
}
